import { userSlice } from './userSlice';

export const {
  setAudioEnabled,
  setVideoEnabled,
  setMediaSettings,
  setMediaSettingsIsOpen,
  setVideoDeviceId,
  setAudioInputDeviceId,
  setMicrophoneIssueDetected,
  setMicrophoneIssueAcknowledged,
  setIsOnline,
  setShowMemberSetupDialog,
} = userSlice.actions;
